import { useReceiptStore } from "@elixir/stores";
import { SERVICE_MASTER_STATUS } from "@elixir/types";
import { useQuery } from "@tanstack/react-query";
import { getServicesMasterAutosuggest } from "apis";
import useQueueStore from "../../../stores/queue-store";
import { useMyAccessProfileV2 } from "../../tryst/get-my-access-profile";

export const getServicesMasterAutosuggestQuery = ({
  query,
  owner_id,
  clinic_id,
}: {
  query?: string;
  owner_id: string;
  clinic_id?: string;
}) => {
  const queryArray = ["get-service-master-autosuggest-query", owner_id];
  if (query) {
    queryArray.push(query);
  }
  if (clinic_id) {
    queryArray.push(clinic_id);
  }
  return queryArray;
};

export default function useGetServicesMasterAutosuggest({
  query = "",
  page,
  pageSize,
  status,
}: {
  query?: string;
  page?: number;
  pageSize?: number;
  status?: SERVICE_MASTER_STATUS;
}) {
  const { data: myProfile } = useMyAccessProfileV2();
  const fallbackClinicId = useQueueStore((state) => state.clinicId);
  const clinicIdFromReceipt = useReceiptStore((state) => state.clinicId);

  const clinic_id = clinicIdFromReceipt || fallbackClinicId;

  return useQuery(
    getServicesMasterAutosuggestQuery({
      query,
      owner_id: myProfile?.business?.id!,
      clinic_id,
    }),
    () =>
      getServicesMasterAutosuggest({
        q: query,
        page,
        pageSize,
        status,
        clinic_id,
      }),
    {
      staleTime: 1000 * 60 * 60 * 2,
    }
  );
}
